import * as types from "../actions/admin.actions";

const INITIAL_STATE = {
  admins: [],
  user: {},
  error: null,
  showToast: false,
  referralCodes: [],
  updatedCode: {},
  referralCode: {},
  project: {},
  loadingCodes: false,
  todo: {},
  projectsOverview: [],
  membersOverview: [],
  weeklyProjects: [],
  weeklyUsers: [],
  notes: [],
  matches: {},
  matches_csv: {},
  feed: [],
  pagination: {},
  sorting: {}
};

export default function(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case types.SET_PAGINATION:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          from: action.data.from,
          to: action.data.to,
          total: action.data.total
        }
      };
    case types.SET_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          [action.data.table]: action.data.pageNumber
        }
      };
    case types.SET_SORT:
      return {
        ...state,
        sorting: { ...state.sorting, [action.data.table]: action.data.sortData }
      };
    case types.SET_USER:
      return { ...state, user: action.data };
    case types.CREATE_ADMIN_SUCCESS:
      return { ...state, user: action.data, showToast: true };
    case types.CREATE_ADMIN_ERROR:
      return { ...state, error: action.error, showToast: false };
    case types.SHOW_TOAST:
      return { ...state, showToast: action.showToast };
    case types.GET_REFERRAL_CODES_START:
      return { ...state, loadingCodes: true };
    case types.GET_REFERRAL_CODES_SUCCESS:
      return { ...state, referralCodes: action.data, loadingCodes: false };
    case types.GET_REFERRAL_CODES_ERROR:
      return { ...state, error: action.error, loadingCodes: false };
    case types.UPDATE_REFERRAL_CODE_SUCCESS:
      return { ...state, updatedCode: action.data };
    case types.UPDATE_REFERRAL_CODE_ERROR:
      return { ...state, error: action.error };
    case types.CREATE_REFERRAL_CODE_SUCCESS:
      return { ...state, referralCode: action.data };
    case types.CREATE_REFERRAL_CODE_ERROR:
      return { ...state, error: action.error };
    case types.SET_ADMIN_PROJECT:
      return { ...state, project: action.data };
    case types.GET_ADMIN_DASHBOARD_TODO_SUCCESS:
      return { ...state, todo: action.data };
    case types.GET_ADMIN_DASHBOARD_TODO_ERROR:
      return { ...state, error: action.error };
    case types.GET_ADMIN_PROJECTS_OVERVIEW_SUCCESS:
      return { ...state, projectsOverview: action.data };
    case types.GET_ADMIN_PROJECTS_OVERVIEW_ERROR:
      return { ...state, error: action.error };
    case types.GET_ADMIN_MEMBERS_OVERVIEW_SUCCESS:
      return { ...state, membersOverview: action.data };
    case types.GET_ADMIN_MEMBERS_OVERVIEW_ERROR:
      return { ...state, error: action.error };
    case types.GET_ADMIN_WEEKLY_PROJECTS_SUCCESS:
      return { ...state, weeklyProjects: action.data };
    case types.GET_ADMIN_WEEKLY_PROJECTS_ERROR:
      return { ...state, error: action.error };
    case types.GET_ADMIN_WEEKLY_USERS_SUCCESS:
      return { ...state, weeklyUsers: action.data };
    case types.GET_ADMIN_WEEKLY_USERS_ERROR:
      return { ...state, error: action.error };
    case types.GET_ADMIN_LIST_SUCCESS:
      return { ...state, admins: action.data };
    case types.GET_ADMIN_LIST_ERROR:
      return { ...state, error: action.error };
    case types.SET_NOTES:
      return { ...state, notes: action.data };
    case types.SET_MATCHES:
      return { ...state, matches: action.data };
    case types.SET_MATCHES_CSV:
      return { ...state, matches_csv: action.data };
    case types.SET_FEED:
      return { ...state, feed: action.data };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/admin.reducer.js